import React from 'react';
import { Search, X } from 'lucide-react';

export const FilterBar = ({ children, onReset, q, setQ, onSearch, placeholder = '검색어를 입력하세요' }) => (
  <div className="flex flex-wrap items-center gap-2 mb-3" data-testid="admin-filter-bar">
    <div className="relative flex-1 min-w-[200px]">
      <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
      <input
        value={q || ''}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && onSearch?.()}
        placeholder={placeholder}
        className="w-full pl-9 pr-3 py-2 border rounded-full bg-white dark:bg-[#141414] border-black/10 dark:border-white/10 text-sm"
        data-testid="admin-search-input"
      />
    </div>
    {children}
    {onReset && (
      <button type="button" onClick={onReset}
        className="text-xs font-bold text-gray-600 dark:text-gray-300 hover:text-[#FF3B30] px-2 py-1"
        data-testid="admin-filter-reset">전체 초기화</button>
    )}
  </div>
);

export const SelectPill = ({ value, onChange, options, testid }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)}
    className="px-3 py-2 border rounded-full bg-white dark:bg-[#141414] border-black/10 dark:border-white/10 text-sm"
    data-testid={testid}>
    {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
  </select>
);

export const ActiveChips = ({ chips, onRemove }) => {
  if (!chips || chips.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5 mb-3" data-testid="active-chips">
      {chips.map((c) => (
        <span key={c.key} className="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-bold rounded-full bg-[#FF3B30]/10 text-[#FF3B30]">
          {c.label}
          <button type="button" onClick={() => onRemove(c.key)} className="hover:opacity-70" aria-label="필터 제거">
            <X size={11} />
          </button>
        </span>
      ))}
    </div>
  );
};

export const Pagination = ({ page, total, pageSize, onChange }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / (pageSize || 20)));
  if (pages <= 1) return null;
  return (
    <div className="flex items-center justify-center gap-1 mt-4" data-testid="admin-pagination">
      <button type="button" disabled={page <= 1} onClick={() => onChange(page - 1)}
        className="px-3 py-1 rounded-md text-xs font-bold bg-black/5 dark:bg-white/10 disabled:opacity-30">이전</button>
      <span className="px-2 text-xs text-gray-500">{page} / {pages}</span>
      <button type="button" disabled={page >= pages} onClick={() => onChange(page + 1)}
        className="px-3 py-1 rounded-md text-xs font-bold bg-black/5 dark:bg-white/10 disabled:opacity-30">다음</button>
    </div>
  );
};

export const StateMsg = ({ loading, empty, error, emptyText = '데이터가 없습니다.' }) => {
  if (error) return <div className="p-10 text-center text-sm text-red-500" data-testid="admin-error">{error}</div>;
  if (loading) return <div className="p-10 text-center text-sm text-gray-500" data-testid="admin-loading">불러오는 중…</div>;
  if (empty) return <div className="p-10 text-center text-sm text-gray-500" data-testid="admin-empty">{emptyText}</div>;
  return null;
};
